import styled from 'styled-components'

import { colors } from '../../../../../../shared/styles/colors'

export const IconMessage = styled.div`
  padding-left: 24px;
  padding-top: 21px;
  padding-bottom: 10px;
  font-size: 30px;
  margin-left: -20px;
  margin-top: -10px;
`

export const ErrorMessage = styled.div`
  margin-left: 20px;
  padding-top: 15px;
  font-size: 12px;
  color: ${colors.red2};
`
export const Message = styled.div`
  margin-left: 20px;
  padding-top: 15px;
  font-size: 12px;
  color: ${colors.gray};
`

export const TextFrotista = styled.div`
  height: 60px;
  padding-left: 20px;
  align-content: 'center';
  align-items: 'center';
  width: 100%;
  font-weight: 700;
`

export const CardFrotista = styled.div`
  background-color: ${colors.white};
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 20px 20px 0px 20px;
  width: 100%;
  margin-bottom: 10px;
`

export const ArrowButton = styled.div`
  padding-top: 15px;
  cursor: pointer;
`
export const TextCnpj = styled.div`
  padding-left: 20px;
  margin-top: -40px;
  padding-bottom: 10px;
`
